import React, { useEffect, useState } from 'react';

type ModalBackdropProps = {
  backdropClass?: string;
  onClick?: () => void;
};

const ModalBackdrop = (props: ModalBackdropProps) => {
  const { backdropClass, onClick } = props;
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setAnimate(true), 0);
    return () => clearTimeout(timeout);
  }, []);

  const zIndex = 1050;

  return (
    <div
      className={`modal-backdrop fade ${backdropClass} ${animate ? 'in' : ''}`}
      style={zIndex ? { zIndex } : {}}
      onClick={(event) => {
        event.stopPropagation();
        if (onClick) {
          onClick();
        }
      }}
    ></div>
  );
};

export default ModalBackdrop;
